import { Awwmageddon } from "./Awwmageddon"
import {Obsession} from "./@Obsession"
import {FullStar} from "./FullStar"
import { GatorHucker} from "./GatorHucker"
import {LSystem} from "./L-System"
import { StickySituation } from "./Sticky Situation"
import { PortfolioWebsite } from "./PortfolioWebsite"

export const ProjectOrder={
        projects:[
            GatorHucker,
            Awwmageddon,
            StickySituation,
            //PortfolioWebsite,
            LSystem,
            Obsession,
            FullStar
        ]
}